// extracted by mini-css-extract-plugin
export default {"auditsTable":"AuditsTable_auditsTable__ujKiT","wrapText":"AuditsTable_wrapText__jAw+l"};